export default __webpack_public_path__ + "static/media/loading.1b1a3876.jpg";